import { Calendar, X } from 'lucide-react';

export default function DateRangePicker({ dateFrom, dateTo, onChange, className = '' }) {
  function clear() { onChange('', ''); }
  const active = dateFrom || dateTo;
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className="flex items-center gap-1.5 bg-white border border-gray-200 rounded-lg px-3 py-2 text-sm shadow-sm">
        <Calendar size={13} className="text-gray-400 flex-shrink-0" />
        <input
          type="date"
          value={dateFrom}
          onChange={e => onChange(e.target.value, dateTo)}
          className="border-none outline-none text-sm text-gray-700 bg-transparent w-32"
          placeholder="From"
        />
        <span className="text-gray-300 mx-1">→</span>
        <input
          type="date"
          value={dateTo}
          onChange={e => onChange(dateFrom, e.target.value)}
          className="border-none outline-none text-sm text-gray-700 bg-transparent w-32"
          placeholder="To"
        />
      </div>
      {active && (
        <button
          onClick={clear}
          className="flex items-center gap-1 px-2 py-1.5 text-xs text-gray-500 border border-gray-200 rounded-lg hover:bg-gray-50"
        >
          <X size={11} /> Clear
        </button>
      )}
    </div>
  );
}
